export default __webpack_public_path__ + "static/media/36I-114288_-21003_0.243203ef.jpg";